import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CrossIcon from '../../components/icons/CrossIcon';
import ExternalLinkIcon from '../../components/icons/ExternalLinkIcon';
import { Body, BodyBold, SubTitleLarge } from '../../components/Typography';
import { Box, Button, styled } from '@mui/material';
import { fontWeight } from '../../theme/typography';
import { HFlex, VFlex } from '../../components/FlexContainers';
import { palette } from '../../theme/palette';
import { PrimaryButton, SecondaryButton } from '../../components/Buttons';

export const Dropdown = styled(Box)`
  display: flex;
  position: relative;
  width: 100%;
`;

export const DropdownButton = styled(SecondaryButton)`
  height: 40px;
  min-width: unset;
  padding: 10px;
  position: relative;
  width: 40px;

  ${(props) => props.theme.breakpoints.down('sm')} {
    height: 30px;
    width: 30px;
    padding: 8px;
  }
`;

export const ArrowContainer = styled(Box)`
  position: absolute;
  right: 10px;
  top: -20px;
`;

export const Arrow = styled(Box)`
  height: 21px;
  overflow: hidden;
  position: relative;
  width: 40px;
  :after {
    background: ${palette.custom.white};
    border-radius: 5px 0 0 0;
    box-shadow: -1px -1px 10px -2px rgba(0, 0, 0, 0.15);
    content: '';
    height: 30px;
    left: 5px;
    position: absolute;
    top: 8px;
    transform: rotate(45deg);
    width: 30px;
  }
`;

export const MenuContentRoot = styled(Box)`
  border-radius: 5px;
  box-shadow: 0px 0px 15px 2px rgba(0, 0, 0, 0.1);
  max-width: 402px;
  position: absolute;
  right: -10px;
  top: 68px;
  width: 95vw;
  z-index: 100;

  ${(props) => props.theme.breakpoints.down('xs')} {
    border-radius: 0px 0px 5px 5px;
    box-shadow: none;
    width: 100%;
    max-width: none;
    position: relative;
    top: 0;
    right: 0;
  }
`;

export const DropdownMenu = styled(Box)`
  background: ${palette.custom.white};
  border-radius: 5px;
  display: grid;
  gap: 0px;
  grid-template-areas: 'AreaOne AreaOne' 'AreaThree AreaTwo' 'AreaFour AreaFour';
  grid-template-columns: minmax(auto, 256px) minmax(auto, 156px);
  grid-template-rows: auto;
  width: 100%;
  box-shadow: 0px 4px 6px 0px #0000001a;

  ${(props) => props.theme.breakpoints.down('xs')} {
    grid-template-areas: 'AreaOne' 'AreaThree' 'AreaTwo' 'AreaFour';
    grid-template-columns: auto;
    max-width: unset;
    border-radius: 0px 0px 5px 5px;
  }
`;

export const AreaOne = styled(Box)`
  grid-area: AreaOne;
  position: relative;
  width: 100%;

  ${(props) => props.theme.breakpoints.down('xs')} {
    background: ${palette.custom.darkGrey};
    display: flex;
    align-items: center;
    height: 71px;
  }
`;

export const AreaTwo = styled(VFlex)`
  grid-area: AreaTwo;
  max-width: 150px;
  position: relative;
  padding: 9px 10px 10px 17px;

  ${(props) => props.theme.breakpoints.down('xs')} {
    padding: 0px 20px 10px 20px;
  }
`;

export const AreaThree = styled(VFlex, {
  shouldForwardProp: (prop) => prop !== 'bottomPadding',
})<{
  bottomPadding?: boolean;
}>`
  grid-area: AreaThree;
  position: relative;
  min-width: 190px;
  margin: 9px 0px 6px 0px;
  padding: 0px 26px 0px 26px;

  ${(props) => props.theme.breakpoints.down('xs')} {
    padding: 0px 1.25rem;
  }
`;

export const AreaFour = styled(HFlex, {
  shouldForwardProp: (prop) => prop !== 'whiteBackground',
})<{
  whiteBackground?: boolean;
}>`
  grid-area: AreaFour;
  align-items: center;
  position: relative;
  background: ${(props) =>
    props.whiteBackground ? palette.custom.white : palette.custom.lightGrey};
  min-height: 34px;
  padding: 0px 26px;

  ${(props) => props.theme.breakpoints.down('xs')} {
    min-height: 40px;
    border-radius: 0px 0px 5px 5px;
    padding: 0px 1.25rem;
  }
`;

export const RightBorder = styled(Box)`
  position: absolute;
  right: 0;
  top: 0;
  width: 1.5px;
  height: 100%;
  background-color: #eeeeeebf;
`;

export const AccountInfo = styled(HFlex)`
  align-items: flex-start;
  background: ${palette.custom.darkGrey};
  border-radius: 6px;
  gap: 32px;
  justify-content: space-between;
  min-height: 38px;
  padding: 12px 12px 12px 12px;
  margin: 17px 26px 10px 26px;

  ${(props) => props.theme.breakpoints.down('xs')} {
    background: none;
    padding: 0;
    align-items: center;
    margin: 0px 20px;
    width: 100%;
  }
`;

export const UserInfo = styled(HFlex)`
  align-items: flex-start;
  gap: 10px;
  ${(props) => props.theme.breakpoints.down('xs')} {
    align-items: center;
  }
`;
export const WelcomeText = styled(Body)`
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 15.1px;
  letter-spacing: 0.3px;
  margin-bottom: 0px;
  color: ${palette.custom.white};
`;

export const UserName = styled(BodyBold)`
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 12.6px;
  align-self: center;
  letter-spacing: 0.25px;
  margin-bottom: 0px;
  text-transform: capitalize;
  word-break: break-word;
  color: ${palette.custom.white};

  ${(props) => props.theme.breakpoints.down('xs')} {
    font-size: 16px;
    font-weight: ${fontWeight.light};
    color: ${palette.custom.white};
  }
`;

export const UserLabel = styled(Body)`
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0.025em;
  line-height: 14px;
  margin-bottom: 0px;
  white-space: nowrap;
  ${(props) => props.theme.breakpoints.down('xs')} {
    font-family: trade-gothic-next-condensed, sans-serif;
    font-size: 20px;
    font-weight: ${fontWeight.heavy};
    color: ${palette.custom.white};
    text-transform: uppercase;
  }
`;

export const ManageProfileLink = styled('a')`
  align-items: center;
  color: ${palette.custom.darkGrey};
  cursor: pointer;
  display: flex;
  font-size: 10px;
  font-weight: 400;
  gap: 2px;
  justify-content: space-between;
  letter-spacing: 0.025em;
  line-height: 12.6px;
  align-self: center;
  margin-bottom: 0px;
  text-decoration: none;
  text-transform: capitalize;
  white-space: nowrap;
  color: ${palette.custom.lightGrey};
`;

export const ManageProfileIconContainer = styled(Box)`
  align-items: center;
  display: flex;
  height: 14px;
`;

export const ManageProfileIcon = styled(ChevronRightIcon)`
  width: 18px;
  padding-top: 2px;
`;

export const SignInWrapper = styled(HFlex)`
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 17px 20px 17px 19px;

  ${(props) => props.theme.breakpoints.down('xs')} {
    padding: 10px 20px;
  }
`;

export const SignInButton = styled(PrimaryButton)`
  width: 100%;
  max-width: 154px;
  height: 40px;
  font-size: 12px;
  font-weight: ${fontWeight.bold};
  line-height: 15.1px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
`;

export const MenuTitle = styled(SubTitleLarge)`
  font-family: 'trade-gothic-next-condensed', 'sans-serif';
  line-height: 28px;

  ${(props) => props.theme.breakpoints.down('xs')} {
    font-size: 16px;
    margin: 10px 0;
  }
`;

export const Links = styled(Box)`
  width: 100%;
`;

export const Link = styled('a')`
  color: ${palette.custom.darkGrey};
  cursor: pointer;
  display: block;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.025em;
  line-height: 24px;
  margin-bottom: 0px;
  text-decoration: none;
  width: fit-content;

  ${(props) => props.theme.breakpoints.down('xs')} {
    font-size: 12px;
    margin: 8px 0px;
  }
`;

export const LogoutLink = styled(Link)`
  ${(props) => props.theme.breakpoints.down('xs')} {
    font-weight: ${fontWeight.bold};
    padding: 4px 0px;
  }
`;

export const LogoutButton = styled(Button)`
  width: 100%;
  margin-top: 15px;
  margin-bottom: 22px;
  height: 40.152px;
  border-radius: 5px;
  border: 1px solid ${palette.primary.main};
  color: ${palette.custom.darkGrey};
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  cursor: pointer;

  &:hover {
    background-color: ${palette.custom.white};
  }
`;

export const LinkIcon = styled('span')`
  margin-left: 5px;
`;

export const ExternalIcon = styled(ExternalLinkIcon)`
  height: 18.5px;
  padding-top: 7px;
  width: 14px;
`;

export const Separator = styled('hr', {
  shouldForwardProp: (prop) => prop !== 'noBottomMargin' && prop !== 'mt' && prop !== 'mb',
})<{
  mt?: number;
  mb?: number;
}>`
  border-top: 2px solid #eeeeeebf;
  border-bottom: 0px;
  border-left: 0px;
  border-right: 0px;
  width: 100%;
  margin-top: ${(props) => (typeof props.mt === 'number' ? props.mt + 'px' : '8px')};
  margin-bottom: ${(props) => (typeof props.mb === 'number' ? props.mb + 'px' : '8px')};
`;

export const SignupContent = styled(HFlex)``;

export const SignupText = styled(Body)`
  font-size: 10px;
  font-weight: ${fontWeight.bold};
  margin-bottom: 0px;
  text-align: center;
  line-height: 32px;
  letter-spacing: 0.25px;
  ${(props) => props.theme.breakpoints.down('xs')} {
    margin-left: 6px;
    color: ${palette.custom.white};
    text-align: right;
  }
`;

export const StartHere = styled(Body)`
  color: ${palette.collection.blue.d400};
  cursor: pointer;
  font-size: 10px;
  font-weight: ${fontWeight.bold};
  line-height: 32px;
  letter-spacing: 0.25px;
  margin-bottom: 0px;
  margin-left: 3px;
  white-space: nowrap;
  ${(props) => props.theme.breakpoints.down('xs')} {
    margin-left: 6px;
  }
`;

export const CloseButton = styled(Box)`
  height: 25px;
  width: 25px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${palette.primary.main};
`;

export const CloseIcon = styled(CrossIcon)`
  color: ${palette.custom.grey};
  width: 21px;
  height: 21px;
  object-fit: contain;
`;
